import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './PromoPreviewItem.css';

export interface IPromoPreviewItemProps {
  icon: string | null;
}

export const PromoPreviewItem: React.FC<IPromoPreviewItemProps> = ({ icon }) => {
  return !icon ? null : (
    <div className={styles['preview']} aria-hidden="true">
      <Image src={icon} width={24} height={24} borderRadius="50%" />
    </div>
  );
};
